import React from "react";
import { Card, CardBody, CardHeader } from "reactstrap";
import { useQuery } from "react-query";
import { getUserById } from "../../Users/services/userApi";
import { Spin } from "antd";

const HeadInspection = ({ vehicleInspection }) => {
  const {
    id,
    brand,
    model,
    statut,
    description,
    transmission,
    speed,
    registrationNumber,
    commissioningDate,
    vin,
    mileage,
    actualUserId,
    fileName,
  } = vehicleInspection || {};

  const { data: driver, isLoading: driverLoading } = useQuery(
    ["driver", actualUserId],
    () => getUserById(actualUserId),
    {
      enabled: !!actualUserId,
    }
  );

  return (
    <Card className="shadow-sm border-0 rounded-lg">
      <CardHeader>
        <h5>Information du véhicule inspécté</h5>
      </CardHeader>
      <CardBody className="p-4">
        <div className="table-responsive mb-0">
          <table className="table table-bordered table-hover">
            <thead className="table-light">
              <tr>
                <th style={{ fontWeight: "normal" }}>Marque</th>
                <th style={{ fontWeight: "normal" }}>Model</th>
                <th style={{ fontWeight: "normal" }}>Plaque</th>
                <th style={{ fontWeight: "normal" }}>En service</th>
                <th style={{ fontWeight: "normal" }}>Transmission</th>
                <th style={{ fontWeight: "normal" }}>Vitesse</th>
                <th style={{ fontWeight: "normal" }}>VIN</th>
                <th style={{ fontWeight: "normal" }}>Kilométrage</th>
                <th style={{ fontWeight: "normal" }}>Chauffeur</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{brand || "-"}</td>
                <td>{model || "-"}</td>
                <td>{registrationNumber || "-"}</td>
                <td>{commissioningDate || "-"}</td>
                <td>{transmission || "-"}</td>
                <td>{speed || "-"}</td>
                <td>{vin || "-"}</td>
                <td>{mileage || "-"}</td>
                <td>
                  {driverLoading ? (
                    <Spin size="small" />
                  ) : (
                    driver ? driver.name : "-"
                  )}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </CardBody>
    </Card>
  );
};

export default HeadInspection;
